import { createContext } from "react";
import { FrequenciesFilterContextType, FrequenciesFilterState } from "../lib/types";

export const emptyState = {
  TSID: '',
  frequency: '',
  modulation: '',
  signalHealth: '',
  signalLevel: {
    filter: '',
    value: 0,
  }
} as FrequenciesFilterState

export const FrequenciesFilterContext = createContext<FrequenciesFilterContextType>({
  filter: {
    TSID: '',
    frequency: '',
    modulation: '',
    signalHealth: '',
    signalLevel: {
      filter: '',
      value: 0,
    }
  },
  setFilter: () => null,
})